import { render, staticRenderFns } from "./CoursePagination.vue?vue&type=template&id=4f674d0c&scoped=true"
import script from "./CoursePagination.vue?vue&type=script&lang=js"
export * from "./CoursePagination.vue?vue&type=script&lang=js"
import style0 from "./CoursePagination.vue?vue&type=style&index=0&id=4f674d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f674d0c",
  null
  
)

export default component.exports